<template>
    <div>
        <!-- 确认提交 -->
        <div v-if="issubmit !== '3'" class="m_container">
            <Header :title="title" :show-left="true" />
            <section v-loading="loading" class="m_section">
                <div class="content">
                    <p class="title">{{ $t('tougao.basic_info') }}</p>
                    <div v-if="memberHeader.length > 0" class="form_list">
                        <div v-for="(item, index) in memberHeader" :key="index">
                            <div class="form_item" :style="[parentUploadStyle_(item)]">
                                <RenderForm :data="member.info" :header="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="content">
                    <p class="title">{{ $t('tougao.zuopin_info') }}</p>
                    <div v-if="zuopinHeader.length > 0" class="form_list">
                        <div v-for="(item, index) in zuopinHeader" :key="index">
                            <div class="form_item" :style="[parentUploadStyle_(item)]">
                                <RenderForm :data="zuopin.info" :header="item" />
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="issubmit === '1'" class="footer">
                    <el-button type="info" class="submitbtn" @click="back">
                        {{ $t('tougao.cancel') }}
                    </el-button>
                    <el-button type="primary" class="submitbtn" @click="confirm">
                        {{ $t('tougao.sure') }}
                    </el-button>
                </div>
            </section>
            <TabBar :current-tab="currentTab" />
        </div>
        <!-- 回执单 -->
        <div v-else v-loading="loading" class="m_container">
            <Header :title="title" :show-left="true" />
            <div class="m_section receipt-wrapper">
                <div ref="pdf">
                    <div class="hd">
                        <h2>{{ $t('tougao.receipt') }}</h2>
                        <p>NO.{{ ticket }}</p>
                    </div>
                    <div class="table_body">
                        <div ref="con_left" class="con_left uls">
                            <div v-if="memberHeader.length > 0">
                                <div
                                    v-for="item in memberHeader"
                                    :key="item.field"
                                    :class="{
                                        lis_wrap:
                                            item.type === 'upload' || item.type === 'CustomUpload'
                                    }"
                                >
                                    <!-- Upload 上传 -->
                                    <template
                                        v-if="
                                            item.type === 'upload' || item.type === 'CustomUpload'
                                        "
                                    >
                                        <RenderForm
                                            :data="member.info"
                                            :header="item"
                                            :is-table="true"
                                        />
                                    </template>
                                    <!-- 其他表单 -->
                                    <div v-else class="lis">
                                        <p class="f_label">{{ item.title }}</p>
                                        <p class="color_9 maohao">:</p>
                                        <p class="f_val">{{ member.info[item.field] }}</p>
                                    </div>
                                </div>
                            </div>
                            <div v-if="zuopinHeader.length > 0">
                                <div
                                    v-for="item in zuopinHeader"
                                    :key="item.field"
                                    :class="{
                                        lis_wrap:
                                            (item.type === 'upload' ||
                                                item.type === 'CustomUpload') &&
                                            item.props.uploadType === 'image'
                                    }"
                                >
                                    <div
                                        v-if="
                                            item.field !== 'thumb_ids' &&
                                                item.type !== 'upload' &&
                                                item.type !== 'CustomUpload'
                                        "
                                        class="lis"
                                    >
                                        <p class="f_label">{{ item.title }}</p>
                                        <p class="color_9 maohao">:</p>
                                        <p class="f_val">{{ zuopin.info[item.field] }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="con_right" :style="{ height: contentHeight }">
                            <!-- 作品 -->
                            <RenderUpload
                                :data="{ thumb_ids_urls: thumb_ids_urls }"
                                :header="{ field: 'thumb_ids_urls' }"
                                :is-table="true"
                                :conHeight="contentHeight"
                            />
                            <!-- 二维码 -->
                            <div class="img_wrap">
                                <VueQr
                                    ref="h5Qrcode"
                                    :text="qr_type_before + zuopin_id + qr_type_after"
                                    :size="150"
                                    class="qr"
                                    style="display:block;margin: 10px auto 0;"
                                />
                            </div>
                        </div>
                    </div>
                    <p class="tip">{{ tougaoSetting.note }}</p>
                </div>
            </div>
            <div class="center_flex">
                <el-button type="primary" class="submitbtn" @click="print">
                    {{ $t('Notification.print') }}
                </el-button>
            </div>
        </div>
        <!-- 打印预览 + 预览图片 -->
        <div v-if="dialogVisible" class="mask">
            <div class="dialog-bottom">
                <p class="mb-20">↑</p>
                <p class="dialog-bottom_txt">长按上方图片选择“保存图片”</p>
                <img
                    src="../../assets/images/icon_gray_close.png"
                    class="icon_close"
                    @click="dialogVisible = false"
                />
            </div>
        </div>
        <!-- 预览图片 -->
        <el-dialog
            :visible.sync="dialogVisible"
            :append-to-body="true"
            style="text-align: center;"
            class="imgDialog"
        >
            <el-image :src="imageUrl" />
        </el-dialog>
    </div>
</template>

<script>
import { downloadPDF } from '@/utils/pdf.js' // 工具方法，导出操作
import VueQr from 'vue-qr'
import Header from '@/components/Header/index'
import TabBar from '@/components/TabBar/index'
import RenderForm from './component/renderForm.vue'
import RenderUpload from './component/renderUpload.vue'
import { mapGetters } from 'vuex'
import { getTid, setTid } from '@/utils/cookies'
import { memberInfo, zuopinInfo, confirmZuopin } from '@/api/Tougaos'

export default {
    name: 'ConfirmTouGao',
    components: { Header, TabBar, VueQr, RenderForm, RenderUpload },
    data() {
        return {
            language: this.$store.getters.language,
            tid: this.$route.query.tid ? this.$route.query.tid : getTid(),
            zuopin_id: this.$route.query.zpid,
            issubmit: this.$route.query.issubmit,
            title: this.$store.getters.language === 'en' ? 'Confirm' : '确认提交',
            loading: false,
            currentTab: 'my',
            ticket: '',
            member: { header: [], header_en: [], info: {} },
            zuopin: { header: [], header_en: [], info: {} },
            thumb_ids_urls: [], // 作品图片
            qr_type_before: '',
            qr_type_after: '}',
            dialogVisible: false,
            imageUrl: '',
            contentHeight: '0',
            downLoadShow: false,
            downLoadUrl: ''
        }
    },

    computed: {
        ...mapGetters(['tougaoSetting', 'domain']),
        parentUploadStyle_() {
            return (item) => {
                const bool =
                    (item.type === 'upload' || item.type === 'CustomUpload') &&
                    (item.props.uploadType === 'image' || item.props.uploadType === 'file')
                return { marginBottom: bool ? '10px' : '0' }
            }
        },
        memberHeader() {
            const { header = [], header_en = [] } = this.member
            return this.language === 'en' ? header_en : header
        },
        zuopinHeader() {
            const { header = [], header_en = [] } = this.zuopin
            return this.language === 'en' ? header_en : header
        }
    },

    created() {
        this.qr_type_before = `{type: '0',ip:'${this.domain.app}',tid:'${this.tid}',id:`

        this.tid ? setTid(this.tid) : ''

        this.loading = true
        Promise.all([this.getMemberInfo(), this.getZuopinInfo(this.zuopin_id)]).then(() => {
            if (this.issubmit === '3') {
                this.contentHeight = this.$refs.con_left.clientHeight + 'px'
            }
            setTimeout(() => {
                this.loading = false
            }, 1000)
        })
        if (this.issubmit === '0') {
            this.title = this.language === 'en' ? 'Detail' : '详情'
        } else if (this.issubmit === '3') {
            this.title = this.language === 'en' ? 'Receipt' : '回执单'
        }
    },

    methods: {
        getMemberInfo() {
            return new Promise((resolve, reject) => {
                memberInfo({ tid: this.tid }).then((res) => {
                    if (res.code === 200) {
                        const { data, header, header_en } = res.data
                        this.member = {
                            header,
                            header_en,
                            info: data.info
                        }
                        // 数组转字符串
                        header.forEach((item) => {
                            if (
                                (item.type === 'cascader' || item.type === 'checkbox') &&
                                typeof this.member.info[item.field] === 'object' &&
                                item.type !== 'upload'
                            ) {
                                this.member.info[item.field] = this.member.info[item.field]
                                    .toString()
                                    .replace(new RegExp(',', 'g'), '/')
                            }
                        })
                        resolve()
                    }
                })
            })
        },

        getZuopinInfo(id) {
            return new Promise((resolve, reject) => {
                zuopinInfo({ id }).then((res) => {
                    if (res.code === 200) {
                        const {
                            data,
                            header,
                            header_en,
                            category_header,
                            category_header_en
                        } = res.data
                        this.zuopin = {
                            header: [...header, ...category_header],
                            header_en: [...header_en, ...category_header_en],
                            info: data.info
                        }
                        this.ticket = data.ticket
                        // 数组转字符串
                        const zp_info = this.zuopin.info
                        this.zuopin.header.forEach((item) => {
                            const { type, field } = item
                            if (
                                (type === 'cascader' || type === 'checkbox') &&
                                typeof zp_info[field] === 'object' &&
                                type !== 'upload' &&
                                type !== 'CustomUpload'
                            ) {
                                zp_info[field] = zp_info[field]
                                    .toString()
                                    .replace(new RegExp(',', 'g'), '/')
                            }
                            if (
                                field === 'thumb_ids' &&
                                zp_info.thumb_ids &&
                                zp_info.thumb_ids.length
                            ) {
                                // this.thumb_ids_urls = typeof (zp_info[field]) === 'string' ? zp_info[field] : zp_info[field][0]
                                this.thumb_ids_urls =
                                    typeof zp_info[field] === 'string'
                                        ? zp_info[field]
                                        : type !== 'CustomUpload'
                                        ? zp_info[field][0]
                                        : zp_info[field][0].url
                                // console.log('this----', this.thumb_ids_urls)
                            }
                        })
                        resolve()
                    }
                })
            })
        },

        back() {
            this.$router.go(-1) // 返回上一层
        },

        confirm() {
            this.$confirm(this.$t('Notification.submit_tip'), this.$t('Notification.tip'), {
                confirmButtonText: this.$t('tougao.sure'),
                cancelButtonText: this.$t('tougao.cancel'),
                type: 'warning'
            })
                .then(() => {
                    confirmZuopin({ id: this.zuopin_id, tid: this.tid }).then(() => {
                        this.$notify({
                            title: this.$t('Notification.suc_title'),
                            message: this.$t('Notification.suc_confirm_msg'),
                            type: 'success',
                            duration: 2000
                        })
                        this.back()
                    })
                })
                .catch(() => {})
        },

        previewImg(url) {
            this.dialogVisible = true
            this.imageUrl = url
        },

        async print() {
            // this.$confirm('请复制链接至电脑端打印', '提示', {
            //     confirmButtonText: '确定',
            //     showCancelButton: false,
            //     type: 'warning'
            // }).then(() => { })
            this.imageUrl = await downloadPDF(this.$refs.pdf)
            this.dialogVisible = true
        },

        download(item) {
            window.open(item, '_blank')
        }
    }
}
</script>

<style lang="less" scoped>
.m_container {
    width: 100%;
    height: 100%;
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #f5f5f5;

    .m_section {
        flex: 1;

        .content {
            margin: 10px;
            padding: 5px;
            background: #fff;

            .title {
                padding: 5px 0;
                font-size: 18px;
                font-weight: bold;
            }

            .member_form_list {
                padding-top: 100px;
            }

            .form_list {
                margin-top: 10px;

                .pic {
                    width: 94px;
                    margin: 0 auto 20px;
                    position: absolute;
                    top: 110px;
                    left: 50%;
                    transform: translateX(-50%);

                    .img {
                        width: 88px;
                    }
                }

                .form_item {
                    padding: 0px 10px;
                    // margin-bottom: 10px;
                    display: flex;
                    justify-content: space-between;
                    align-items: center;
                    font-size: 12px;
                    color: #4d4c4c;

                    .form_label {
                        width: 80px;
                        color: #999;
                        text-align: right;
                        margin-right: 10px;
                        display: inline-block;
                        text-align: justify;
                        text-align-last: justify;
                        text-justify: inter-ideograph;
                        // height: 40px;
                        // line-height:0px;

                        &:after {
                            //  content: '';
                            //  width: 100%;
                            //  display: inline-block;
                            display: inline-block; /*行内元素*/
                            content: '';
                            width: 100%; /*可以挤掉文字，保证不跟文字在同一行*/
                            height: 0;
                            visibility: hidden;
                        }
                    }

                    .maohao {
                        margin-top: -14px;
                    }

                    .form_value {
                        flex: 1;
                        padding: 0 10px;
                        text-align: left;
                        overflow: hidden;
                        white-space: nowrap;
                        text-overflow: ellipsis;
                        margin-top: -14px;
                    }

                    .img {
                        width: 60px;
                    }

                    .img_wrap {
                        display: flex;
                        align-items: center;

                        .img {
                            margin: 0 5px;
                        }
                    }

                    .video_img {
                        width: 90px;
                        height: 90px;
                    }
                }
            }
        }

        .footer {
            margin: 20px 10px 10px;
            display: flex;
            justify-content: center;
            align-items: center;
        }

        .submitbtn {
            width: 90%;
        }

        .qr {
            margin-bottom: 10px;
        }

        .form_value_flex {
            width: 100%;
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            align-items: center;

            .uploadImg {
                width: 50px;
                height: 50px;
                cursor: pointer;
            }
        }

        .form_container {
            flex: 1;
            display: flex;
            flex-wrap: wrap;
            align-items: center;
        }
    }
}

.imgDialog /deep/ .el-dialog {
    width: 90%;
    .el-dialog__body {
        padding: 4px 20px;
    }

    img {
        width: 100%;
        height: 100%;
    }
}

.receipt-wrapper {
    padding: 60px 16px 0;
    line-height: 26px;
    font-size: 12px;

    .hd {
        padding: 20px 10px;
        background: #fff;
        line-height: 20px;
        border-bottom: 1px solid #f5f5f5;

        h2 {
            font-size: 20px;
            text-align: center;
            font-family: PingFang;
            margin-bottom: 10px;
        }

        p {
            text-align: center;
            line-height: 20px;
            font-size: 12px;
            color: #999;
        }
    }

    .table_body {
        width: 100%;
        padding: 10px 10px 0;
        background: #fff;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .con_left {
            flex: 3;

            .lis {
                display: flex;
                justify-content: space-between;
                align-items: center;
                text-align: left;

                .f_label {
                    flex: 0 0 100px;
                    padding: 4px 6px;
                    color: #000 !important;
                    display: inline-block;
                    text-align: justify;
                    text-align-last: justify;
                    line-height: 12px;

                    &:after {
                        display: inline-block; /*行内元素*/
                        content: '';
                        width: 100%; /*可以挤掉文字，保证不跟文字在同一行*/
                        height: 0;
                        visibility: hidden;
                    }
                }

                .maohao {
                    margin-top: -10px;
                }

                .f_val {
                    flex: 2;
                    padding: 0 10px;
                    margin: 0;
                    margin-top: -10px;
                    color: #999;
                }
            }

            .lis_wrap {
                margin-bottom: 10px;
            }
        }

        .con_right {
            flex: 1;
            width: 100%;
            padding: 10px 0;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: space-between;

            .img_wrap {
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;

                img {
                    width: 90px;
                }
            }
        }
    }

    .tip {
        background: #fff;
        padding: 6px 10px;
        text-align: left;
        font-size: 6px;
    }

    .center_flex {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .submitbtn {
        margin: 10px auto;
        text-align: center;
        padding: 8px 12px;
        font-size: 12px;
        width: 100px !important;
    }
}
.mask {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    overflow: auto;
    margin: 0;
    text-align: center;
    background: rgba(0, 0, 0, 0.5);
    z-index: 2001;
}
.dialog-bottom {
    text-align: center;
    z-index: 2003;
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #fff;
}
.dialog-bottom_txt {
    color: #fff;
    font-size: 14px;
    margin-bottom: 10px;
}
.icon_close {
    width: 40px;
    height: 40px;
}
</style>
